<template>
    <div id="hoteles-list">
        <div class="section-header d-flex mx-4">
        <!-- <b-alert show class="section-header d-flex mx-1"> -->
            <h3 class="my-2"> {{ listaNum }} Hoteles encontrados </h3>
            <div class="select-view ml-auto" style="font-size: 3rem;">
                <b-icon-grid class="border rounded p-2" @click="vista='G'"></b-icon-grid>
                <b-icon-view-stacked class="border rounded p-2" @click="vista='L'"></b-icon-view-stacked>
            </div>
        <!-- </b-alert> -->
        </div>

        <div class="row mx-1">
            <aside class="col-xs-12 col-md-6 col-lg-3 mb-3 left-sidebar">
                <div class="card">
                    <div class="card-body">
                        <div class="card-body-title">
                            <h5 class="widget-title">Busqueda</h5>
                        </div>
                        <!-- Tipo Estancia -->
                        <div class="form-choise-transport d-flex align-items-center">
                            <!-- <img class="pr-3" src="/img/map-marker-icon.svg" alt=""> -->
                            <div class="form-group">
                                <label class="text-small" for="selectTransport">¿Elije la Estancia?</label>
                                <b-form-select v-model="tipoEstancia" @change="changeTipoEstancia"
                                    :options="tiposEstancia"
                                    class="mb-1"
                                ></b-form-select>
                            </div>
                        </div>
                        <!-- Destinos -->
                        <div class="form-destination d-flex align-items-center">
                            <!-- <img class="pr-3" src="/img/map-marker-icon.svg" alt=""> -->
                            <div class="form-group">
                                <label class="text-small" for="selectDestination">Destino</label>
                                <!-- <b-form-select v-model="destino" @change="filtraHoteles"                                     -->
                                <b-form-select v-model="destino"
                                    :options="destinos"
                                    class="mb-1"
                                ></b-form-select>
                            </div>
                        </div>
                        <!-- Boton Disponibilidad  -->
                        <div class="text-center">
                            <b-btn @click="hotel_dispo" size='sm'
                                class="m-1" variant="outline-primary">Disponibilidad
                            </b-btn>
                        </div>
                    </div>
                </div>
            </aside>

            <!-- Resultados Hoteles (izda) -->
                <div v-if="vista==='G'" class="col d-flex flex-wrap">
                    <div class="col-xs-12 col-lg-4"
                        v-for="item in hotelesFiltrados" :key="item.hot">
                        <hotel :item="item"></hotel>
                    </div>
                </div>
                <div v-else class="col-12 col-lg-9">
                    <div class="card card-hotel-large"
                        v-for="item in hotelesFiltrados" :key="item.hot">
                        <hotel :item="item"></hotel>
                    </div>
                </div>
        </div>

        <!-- Modal Precios -->
        <!-- <hotelPrecios></hotelPrecios>   -->
        <!-- <confianza/> -->

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex'; //store

import hotel from '@/components/hotel.vue'

export default {
    name: 'hoteles',
    components: {
        hotel,

    },
    data() {
        return {
            modulo: 'Hoteles',

            //listaHoteles: [],
            //listaTipoEstancia: [],
            vista: 'G', //G=grid,F=Fila
            // valores de filtros
            tipoEstancia: null,
            destino: null,
        }
    },

    //async created() {
    async mounted() {
    //if (this.listaHoteles.length==0)
        await this.hoteles(); //leemos hoteles disponibles
    },

    computed: {
        ...mapState(['auth','datos','errores','G']),

        listaHoteles() {
            return this.$store.state.hoteles.hoteles;
        },
        listaTipoEstancia() {
            return this.$store.state.hoteles.tipoEstancia;
        },

        hotelesFiltrados() {
            var H=this.$util.object_array(this.listaHoteles);

            /*  // por noches ...
                if (this.tipoEstancia!==null) {
                H = H.filter(item => item.noc.indexOf(this.tipoEstancia) != -1);
            } */
            // por tipo estab.
            if (this.tipoEstancia!==null) {
                //H = H.filter(item => item.tp.indexOf(this.tipoEstancia) != -1);
                H = H.filter(item => item.tp==this.tipoEstancia);
            }
            if (this.destino!==null) {
                H = H.filter(item => item.pobla === this.destino);
            }
            return this.$util.array_object(H);
        },
        listaNum() {
            return Object.keys(this.hotelesFiltrados).length;
        },
        destinos() {
            var lista=(this.tipoEstancia!==null ? this.hotelesFiltrados : this.listaHoteles);
            let result=this.$util.array_valores(lista,'pobla') || [];
            var A=[{text:"¿A dónde quieres ir?", value:null, disabled:false}];
            result.forEach(value => {
                A.push({text:value, value:value, disabled:false});
            });
            return A;
        },
        tiposEstancia() {
            //let result=this.$util.object_array(this.listaTipoEstancia);
            let result=this.listaTipoEstancia || [];
            var A=[{text:"Selecciona", value:null, disabled:false}];
            result.forEach(item => {
                A.push({text:item.name, value:item.id, disabled:false});
            });
            return A;
        },

    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec','error']),

        async hoteles() {

            // leemos con datos_iniciales
            //await this.$store.dispatch('hoteles');
        },

        // informacion establecimiento
        async hotel_info(hotel) {
            this.$store.state.hoteles.hotel=hotel;
            this.$router.push('/hotel-info');
        },

        // Turnos, precios hotel seleccionado
        async hotel_precios(hotel) {
            /* this.$store.state.hoteles.hotel=item;
            await this.$store.dispatch('hotel_precios', item);
            this.$bvModal.show("modal_hotelPrecios"); */
            await this.$root.$hotelPrecios(hotel);
        },

        async hotel_dispo() {
            //this.$bvModal.show("modal_hotelDispo");
            await this.$root.$hotelDispo();
        },

        /* imagen(hot) {
            return this.G.url_img + '?w=123|vc_agencias|hoteles_img|||' + hot;
        }, */

        changeTipoEstancia(evt) {
            console.log('*changeTipoEstancia',evt);
            this.destino=null;
        }

    },

}
</script>
